export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENT = 'SET_EVENT';
export const ADD_EVENT = 'ADD_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const REMOVE_EVENT = 'REMOVE_EVENT';
export const CLEAR_EVENT = 'CLEAR_EVENT';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
